import { render, staticRenderFns } from "./_PrizeItem.vue?vue&type=template&id=7f601120&scoped=true"
import script from "./_PrizeItem.vue?vue&type=script&lang=ts"
export * from "./_PrizeItem.vue?vue&type=script&lang=ts"
import style0 from "./_PrizeItem.vue?vue&type=style&index=0&id=7f601120&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f601120",
  null
  
)

export default component.exports